/**
 * Flag global de "tour activo". Permite a componentes que abren paneles/inputs durante un tour
 * (CreateConnectionPanel, ConnectionTaskSplitPanel, ConnectionHeader…) desactivar su autofocus mientras el tour
 * está en curso: robar el foco distrae del spotlight y deja al usuario escribiendo sin querer.
 *
 * Vive en `window` a propósito: el tour ya se comunica con la app vía eventos `window`
 * (klonup:tour-starting / tour-closed), y un panel se monta DESPUÉS de arrancar el tour, así que
 * no puede captar el evento de inicio — necesita consultar el estado actual al montar. OrgLayout
 * es el único que escribe el flag; los componentes solo lo leen.
 */

const FLAG_KEY = '__klonupTourActive';

interface TourFlagWindow {
  [FLAG_KEY]?: boolean;
}

export function setTourActive(active: boolean): void {
  (window as TourFlagWindow)[FLAG_KEY] = active;
}

export function isTourActive(): boolean {
  return (window as TourFlagWindow)[FLAG_KEY] === true;
}
